import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';

export default class NotificationItemPlaceholder extends PureComponent {
  render() {
    return (
      <div className="notification__item__placeholder">
        <I18n label="notification.placeholder" />
      </div>
    );
  }
}
